(() => {
  function init(scope=document){
    scope.querySelectorAll('.sn2-review-list').forEach(list=>{
      if(list.dataset.snToggleReady||list.children.length<3)return;
      list.dataset.snToggleReady='true';
      const cards=[...list.children];
      const button=document.createElement('button');
      button.type='button';button.className='sn2-review-list-toggle';button.textContent='Read more reviews';button.setAttribute('aria-expanded','false');
      cards.slice(2).forEach(card=>card.classList.add('sn2-mobile-hidden'));
      button.addEventListener('click',()=>{
        const expanded=button.getAttribute('aria-expanded')!=='true';
        button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?'Read fewer reviews':'Read more reviews';
        cards.slice(2).forEach(card=>card.classList.toggle('sn2-mobile-hidden',!expanded));
      });
      list.after(button);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
